// HOUSE.js
import houseFront from '../img/houseImg/01HouseFront.jpg';
import housePanel from '../img/houseImg/02Panel.png';
import houseLiving1 from '../img/houseImg/03Sala.jpg';
import houseLiving2 from '../img/houseImg/04Sala.jpg';
import houseKitchen from '../img/houseImg/05Cocina.jpg';
import houseDining from '../img/houseImg/06Comedor.jpg';
import houseLiving3 from '../img/houseImg/07Livingroom.jpg';
import houseYard1 from '../img/houseImg/08Patio.jpg';
import houseYard2 from '../img/houseImg/09Patio.jpg';
import houseBedroom from '../img/houseImg/10Dormitorio.jpg';
import housePlan from '../img/houseImg/11Plan.jpg';

export const houseImages = [
  { src: houseFront, altText: 'Fachada', caption: 'Fachada' },
  { src: housePanel, altText: 'Paneles solares', caption: 'Paneles solares sobre el garage' },
  { src: houseLiving1, altText: 'Living Room 1', caption: 'Propuesta diseño sala' },
  { src: houseLiving2, altText: 'Living Room 2', caption: 'Propuesta diseño sala' },
  { src: houseKitchen, altText: 'Kitchen', caption: 'Cocina' },
  { src: houseDining, altText: 'Dining Room', caption: 'Comedor' },
  { src: houseLiving3, altText: 'Living Room 3', caption: 'Sala' },
  { src: houseYard1, altText: 'Yard 1', caption: 'Patio' },
  { src: houseYard2, altText: 'Yard 2', caption: 'Patio' },
  { src: houseBedroom, altText: 'Dormitorio', caption: 'Con walk-in closet' },
  /*{ src: housePlan, altText: 'Plan', caption: 'Plan' }*/
];

export const houseImgNotCarousel = [
    { src: housePlan, altText: 'Plan' , caption: 'Plan' }
]


